module.exports = __webpack_public_path__ + "static/media/bold_Times New Roman.c49cfe1c.ttf";